/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tinydesk_NavInputs */

const en_tinydesk_nav = /** @type {(inputs: Tinydesk_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiny Desk AI`)
};

/**
* | output |
* | --- |
* | "Tiny Desk AI" |
*
* @param {Tinydesk_NavInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const tinydesk_nav = /** @type {((inputs?: Tinydesk_NavInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tinydesk_NavInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_tinydesk_nav(inputs)
});
export { tinydesk_nav as "tinydesk.nav" }